// extracted by mini-css-extract-plugin
module.exports = {"rightBlock":"rightBlock--Gn6EH"};